import * as React from 'react';
import classNames from 'classnames';
const styles = require('./Button.less') as any;

import isArray from 'lodash/isArray'
import isString from 'lodash/isString'
const childrenToString = children => isArray(children) ? children.filter(isString).join(' ') : children
const Button = (({kind='primary', children, className, ...props}) => (
	<button data-text={childrenToString(children)}
					className={classNames(styles.button, styles[kind], ...className)} {...props}>
    <span style={{position: 'absolute', left: 0, right: 0, pointerEvents: 'none'}}>{children}</span>
  </button>
) as any);

export default Button;



// WEBPACK FOOTER //
// ./src/app/components/Button/Button.tsx